import { render } from "./IconRequests.vue?vue&type=template&id=48305025"
import script from "./IconRequests.vue?vue&type=script&lang=js"
export * from "./IconRequests.vue?vue&type=script&lang=js"
script.render = render

export default script